import { render, staticRenderFns } from "./lockPriceUser.vue?vue&type=template&id=2c830fa3&scoped=true"
import script from "./lockPriceUser.vue?vue&type=script&lang=js"
export * from "./lockPriceUser.vue?vue&type=script&lang=js"
import style0 from "./lockPriceUser.vue?vue&type=style&index=0&id=2c830fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c830fa3",
  null
  
)

export default component.exports